<h2 class="title">Ustaw nowe hasło</h2>
<div class="register-container">

  <form [formGroup]="resetForm" (ngSubmit)="onSubmit()">
    <input type="hidden" formControlName="email" />
    <input type="hidden" formControlName="token" />

    <mat-form-field appearance="outline" class="form-field">
      <mat-label>Nowe hasło</mat-label>
      <input matInput type="password" formControlName="password" required>
      @if (resetForm.get('password')?.hasError('required')) {
        <mat-error>
          Hasło jest wymagane.
        </mat-error>
      }
      @if (resetForm.get('password')?.hasError('minlength')) {
        <mat-error>
          Hasło musi mieć co najmniej 6 znaków.
        </mat-error>
      }
    </mat-form-field>

    <mat-form-field appearance="outline" class="form-field">
      <mat-label>Potwierdź hasło</mat-label>
      <input matInput type="password" formControlName="confirmPassword" required>
      @if (resetForm.hasError('mismatch')) {
        <mat-error>
          Hasła nie są takie same.
        </mat-error>
      }
    </mat-form-field>

    <button class="custom-button" mat-raised-button color="primary" type="submit" [disabled]="resetForm.invalid">
      Zmień hasło
    </button>

    @if (errorMessage) {
      <div class="error-message">{{ errorMessage }}</div>
    }
    @if (successMessage) {
      <div class="success-message">{{ successMessage }}</div>
    }
  </form>
</div>